import { useIntl } from 'react-intl'
import { styled } from 'styled-components'

import { UnstyledButton } from '@b-stock/fe-core/bstock-next/components'
import { Colors } from '@b-stock/fe-core/design-system'

import type { KeyedMedia } from '../types'

const MAX_DOTS = 11

const Strip = styled.div`
  align-items: center;
  display: flex;
  gap: 0.375rem;
  justify-content: center;
`

const Dot = styled(UnstyledButton)<{ $active: boolean }>`
  background: ${(o) =>
    o.$active ? Colors.Semantic.Neutral.white : 'rgba(255,255,255,0.35)'};
  border-radius: 50%;
  flex-shrink: 0;
  height: ${(o) => (o.$active ? '0.5rem' : '0.375rem')};
  transition:
    background 0.15s,
    height 0.15s,
    width 0.15s;
  width: ${(o) => (o.$active ? '0.5rem' : '0.375rem')};
`

const getDotWindow = (count: number, activeIndex: number) => {
  if (count <= MAX_DOTS) {
    return { start: 0, end: count }
  }
  const half = Math.floor(MAX_DOTS / 2)
  const start = Math.max(0, Math.min(activeIndex - half, count - MAX_DOTS))
  return { start, end: start + MAX_DOTS }
}

export const DotStrip = ({
  items,
  currentIndex,
  onDotClick,
}: {
  items: KeyedMedia[]
  currentIndex: number
  onDotClick: (index: number) => void
}) => {
  const { formatMessage } = useIntl()
  const { start, end } = getDotWindow(items.length, currentIndex)

  return (
    <Strip>
      {items.slice(start, end).map((item, i) => {
        const index = start + i
        return (
          <Dot
            key={item.key}
            $active={index === currentIndex}
            aria-label={formatMessage(
              { id: 'Auction.details.enhancedGallery.lightbox.dot' },
              { index: index + 1 }
            )}
            onClick={() => onDotClick(index)}
          />
        )
      })}
    </Strip>
  )
}
